import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import useStyles from "./styles";

export const DownloadTemplate = () => {
  const classes = useStyles();
  const { hasMultiplePaygroups } = usePartnerConfig();

  const templatePath = hasMultiplePaygroups
    ? "/batch_file_template_with_paygroup.xlsx"
    : "/batch_file_template.xlsx";

  const logDownloadClickedEvent = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.DownloadTemplateClicked,
      payload: { type: "cycle" },
    });
  };

  return (
    <Link
      to={templatePath}
      target="_blank"
      download
      className={classes.downloadButton}
      onClick={logDownloadClickedEvent}
    >
      <GetAppIcon color="primary" />
      <Typography className={classes.downloadText}>
        Download Template
      </Typography>
    </Link>
  );
};
